const USER_KEY = 'dashboard_user';

function generateDeviceId(): string {
  const rand = Math.random().toString(36).slice(2, 8);
  return `guest-${rand}`;
}

export function getCurrentUser(): string {
  const cached = localStorage.getItem(USER_KEY);
  if (cached && cached.trim()) return cached.trim();
  const envUser = process.env.REACT_APP_USER_ID;
  const identity = envUser?.trim() || generateDeviceId();
  localStorage.setItem(USER_KEY, identity);
  return identity;
}

export function setCurrentUser(name: string): void {
  localStorage.setItem(USER_KEY, name.trim() || generateDeviceId());
}
